import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'sn',
    fullName: 'Shona',
    nativeName: 'ChiShona',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Chimwe Chinhu Chinoshamisa Chiri Kuuya",
    landing_subtitle: "ArgVoid ndeye app uye mutambo wekuvandudza studio. Ramba wakatarisa, zvinhu zvitsva zviri kuuya munguva pfupi!",
    select_language: "Sarudza Mutauro",
    search_placeholder: "Tsvaga mitauro...",
    terms_title: "Terms of Service",
    policy_title: "Privacy Policy",
    cookies_title: "Cookie Policy",
    terms_content: `
        <strong>1. Kugamuchirwa kweMatemu</strong><br>
        Nekuwana ArgVoid, aya Matemu eSevhisi anogamuchirwa. Kana zvitemo izvi zvikasabvumirana, sevhisi haifanire kushandiswa.<br><br>

        <strong>2. Platform Usage</strong>X<br>
        ArgVoid uye mashandisirwo ayo anopihwa "sezvazviri" zveruzivo uye zvekugadzira zvinangwa. Sevhisi iyi inofanirwa kushandiswa pazvinhu zviri pamutemo chete.<br>X<br>

        <strong>3. Inorambidzwa Maitiro</strong><br>
        Kushandisa kusakuvara kwesaiti, kutumira spam, kana kuedza kupinda zvisina mvumo kune zvivakwa kunorambidzwa zvachose.<br><br>

        <strong>4. Disclaimer</strong><br>
        Chikuva nemasevhisi anogona kugadziridzwa chero nguva pasina chiziviso. Hapana waranti inopihwa maererano nekukwira kana kuwanikwa kwesevhisi.
    `,
    policy_content: `
        <strong>1. Kuunganidzwa Kweruzivo</strong>X<br>
        Iyi puratifomu haidi kuvimbiswa kwemushandisi kana kugadzira account panguva ino. Hapana ruzivo rwekuzvizivisa (zvakadai semazita kana kero yeemail) inounganidzwa kubva kune vashanyi.<br><br>

        <strong>2. Kushandisa Data</strong>X<br>
        Basic, anonymized analytics inogona kuunganidzwa kuti unzwisise saiti traffic uye kugadzirisa maapplication. Iyi data haina kubatanidzwa kune ega ega mushandisi kuzivikanwa.<br>X<br>

        <strong>3. Wechitatu-Bato Services</strong><br>
        Vechitatu-bato vanopa vanogona kushandiswa kubata uye analytics masevhisi. Maitiro ekuvanzika kweava vanopa anotonga data risingazivikanwe rakagadziriswa pazvivakwa zvavo.<br><br>

        <strong>4. Data Security</strong><br>
        Zvinonzwisisika kuchengetedza matanho anoitwa kuchengetedza chikuva. Zvisinei, hapana nzira yekufambisa paInternet yakachengeteka zvachose.<br><br>
    `,
    cookies_content: `
        <strong>1. Chii chinonzi Cookies uye Local Storage?</strong><br>
        Makuki uye bhurawuza chengetedzo yenzvimbo madiki edata mafaira akachengetwa pamudziyo kuti urangarire magadzirirwo aunofarira pakushanya.<br><br>

        <strong>2. Kushandisa Chinangwa</strong>X<br>
        Browser LocalStorage inoshandiswa zvakasimba kuchengetedza zvigadziriso, se: <br>
        - Zvido zvemutauro<br>
        -Mushandisi interface kumisikidzwa (semuenzaniso, marongero kana dingindira marongero)<br>
        - Yenguva pfupi yekushandisa cache<br><br>

        <strong>3. Hapana Tracking</strong><br>
        Makuki uye chengetedzo yemunharaunda haishandiswe kushambadzira kana yechitatu-bato yekutevera zvinangwa. Yese data yakachengetwa ndeyekunyanya kushanda kwepakati pepuratifomu.<br><br>

        <strong>4. Control</strong><br>
        Browser data inogona kucheneswa chero nguva kuburikidza nebrowser marongero, ayo anozogadzirisa chero zvigadziriso zvemuno.
    `,
    cookie_consent_text: "Isu tinoshandisa makuki ekutanga kuona kuti webhusaiti inoshanda nemazvo, sekuchengeta chikamu chako chichishanda, kuchengetedza mutauro waunofarira, uye mamwe magadzirirwo etsika.",
    read_policy: "Verenga Cookie Policy",
    support_title: "Bata Rutsigiro",
    support_subject_label: "Chidzidzo",
    support_message_label: "Mharidzo",
    support_submit_button: "Send Message",
    support_hint: "Ongorora: Izvi zvinovhura email yako yekusarudzika kutumira meseji.",
    support_success_msg: "Kuvhura email yako app...",
    support_error_msg: "Tatadza kutumira meseji. Ndapota edza zvakare gare gare.",
    explorer_title: "Explorer",
    history_title: "Nhoroondo",
    animation_title: "Animation",
    config_title: "Configuration",
    tool_mouse: "Sarudza (Ctrl+M)",
    tool_brush: "Bhurasha (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Yakasimba/Pachena)",
    tool_eraser: "Eraser (Ctrl+E)",
    tool_brush_size: "Rongedza Saizi Yebhurashi",
    tool_bucket: "Zadza (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Gridhi (Ctrl+Shift+B)",
    tool_rotate: "Tenderedza (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Upamhi",
    label_height: "Urefu",
    label_frames: "Nhamba Yemaframes",
    label_animation: "Animation Style",
    label_background_color: "Background Ruvara",
    label_interval: "Interval",
    tool_anim_config: "Animation Configuration",
    label_new_width: "New Width",
    label_new_height: "New Height",
    label_apply: "Shandisa",
    label_colors: "Colors",
    label_size: "Size",
    label_tolerance: "Kushivirira",
    val_horizontal: "Horizontal",
    val_vertical: "Vertical",
    val_sequence: "Kutevedzana",
    val_bounce: "Bounce",
    val_random: "Random",
    val_solid: "Solid",
    val_clear: "Pachena",
    action_add_sheet: "New Sheet",
    action_import: "Import",
    action_export: "Export",
    action_sort_projects: "Ronga",
    sort_date_old: "Chekutanga Chekutanga",
    sort_date_new: "Newest First",
    sort_name_az: "Zita (A-Z)",
    sort_name_za: "Zita (Z-A)",
    action_new_sprite: "New Sprite",
    action_new_project: "New Project",
    modal_save_all_title: "Sevha Zvose Zvachinja",
    modal_save_all_desc: "Sarudza zvinhu zvekuchengeta:",
    modal_save_selected: "Save Selected",
    action_saved: "Saved",
    modal_create_sprite_title: "Gadzira New Sprite",
    modal_create_project_title: "Gadzira New Project",
    modal_add_sheet_title: "Wedzera Bepa Idzva",
    modal_rename_sheet_title: "Rename Sheet",
    modal_rename_sprite_title: "Rename Sprite",
    modal_delete_sprite_title: "Delete Sprite",
    modal_delete_project_title: "Delete Project",
    modal_delete_sheet_title: "Delete Sheet",
    placeholder_sprite_name: "Zita",
    placeholder_project_name: "Zita",
    placeholder_sheet_name: "Zita",
    placeholder_new_name: "Zita Idzva",
    action_create: "Create",
    action_add: "Wedzera",
    action_rename: "Rename",
    action_duplicate: "Duplicate",
    action_delete: "Delete",
    action_cancel: "Cancel",
    confirm_delete_sprite: "Une chokwadi chekuti unoda kudzima sprite iyi?",
    confirm_delete_project: "Une chokwadi chekuti unoda kudzima chirongwa ichi? Masprites ese achabviswa.",
    confirm_delete_sheet: "Une chokwadi chekuti unoda kudzima bepa iri?",
    err_select_sprite: "Ndapota sarudza sprite kutanga.",
    err_select_project: "Ndapota sarudza chirongwa chekutanga.",
    err_name_empty: "Zita harigone kuva risina chinhu.",
    err_sprite_exists: "Sprite ine zita iroro yatovepo.",
    err_project_exists: "Chirongwa chine zita iroro chatovako.",
    err_no_content: "Hapana zvekuchengetedza.",
    err_no_changes: "Hapana shanduko yekuchengetedza.",
    err_delete_last_sheet: "Hatikwanise kudzima shizha rekupedzisira.",
    err_extract_frames: "Hatina kukwanisa kubvisa chero mafuremu.",
    err_indexeddb: "Tatadza kuchengetedza munharaunda. Browser yako inogona kusatsigira IndexedDB.",
    msg_upload_success: "Kurodha Kwabudirira: {0}",
    msg_upload_failed: "Zvakundikana: {0}",
    msg_save_success: "Kuchengeta kwakabudirira.",
    msg_saving: "Kuchengeta...",
    msg_multi_save_result: "Yakachengetedzwa {0} zvinhu. {1} kukundikana.",
    menu_title: "Menu",
    menu_save: "Sevha",
    menu_save_all: "Sevha Zvose",
    menu_support: "Bata Rutsigiro",
    label_local_storage: "Nzvimbo Yekuchengetera",
    label_sign_in: "Nyorera mu",
    modal_export_title: "Export Sprite",
    label_filename: "Filename",
    label_format: "Format",
    action_export_confirm: "Export",
};

export default translations;
